// Manifesto chapters, creators (placeholders), social mockups, community.
import lifeFestival from "@/assets/social/festival.jpg";
import lifeNeon from "@/assets/social/neon.jpg";
import lifePilates from "@/assets/social/pilates.jpg";
import lifeHome from "@/assets/social/home.jpg";
import lifeTravel from "@/assets/social/travel.jpg";
import lifeFacepaint from "@/assets/social/facepaint.jpg";

export const MANIFESTO = [
  {
    n: "01",
    color: "#FF3366",
    title: { de: "We don't treat symptoms.", en: "We don't treat symptoms." },
    body: {
      de: "Wir gehen die Ursachen eines ungesunden Alltags an. Zucker, Stress, schlechter Schlaf – das sind die echten Störenfriede. Nicht du.",
      en: "We tackle the causes of an unhealthy lifestyle. Sugar, stress, bad sleep — these are the real troublemakers. Not you.",
    },
  },
  {
    n: "02",
    color: "#B084FF",
    title: { de: "Your health first.", en: "Your health first." },
    body: {
      de: "Der Alltag zieht dir Energie ab. Wir drehen den Spieß um: Du bist nicht das Problem – du bist die Lösung.",
      en: "Everyday life drains your energy. We flip it: you're not the problem — you're the solution.",
    },
  },
  {
    n: "03",
    color: "#00CFA8",
    title: { de: "Not perfection. Not abstinence.", en: "Not perfection. Not abstinence." },
    body: {
      de: "Keine Dogmen. Sondern kleine tägliche Entscheidungen für ein besseres Leben – mit einem Grinsen im Gesicht.",
      en: "No dogmas. Just small daily decisions for a better life — with a grin on your face.",
    },
  },
  {
    n: "04",
    color: "#FF6600",
    title: { de: "Mindset. Motivation. Community.", en: "Mindset. Motivation. Community." },
    body: {
      de: "Positivity, Fokus und eine gesunde Einstellung zum Leben: Jeder Moment ist ein Geschenk. Disziplin und positives Denken sind die perfekten Antriebsfedern für ein gesundes, balanciertes Leben – und dafür stehen wir und die Community, weil gemeinsam alles möglich ist. Fight for yourself.",
      en: "Positivity, focus and a healthy attitude to life: every moment is a gift. Discipline and positive thinking are the perfect driving springs for a healthy, balanced life — that's what we and the community stand for, because together anything is possible. Fight for yourself.",
    },
  },
];

export const ENEMIES = [
  { emoji: "candy", color: "#FF3366", de: "Sugar", en: "Sugar" },
  { emoji: "storm", color: "#00CFA8", de: "Stress", en: "Stress" },
  { emoji: "moon", color: "#B084FF", de: "Sleeplessness", en: "Sleeplessness" },
  { emoji: "phone", color: "#FF6600", de: "Doomscrolling", en: "Doomscrolling" },
  { emoji: "burger", color: "#D4FF00", de: "Junk Food", en: "Junk Food" },
];

export const CREATORS = [
  {
    name: "Mia Kellner",
    handle: "@miakampft",
    role: { de: "Stress Warrior", en: "Stress Warrior" },
    fights: { de: "Stress Balance", en: "Stress Balance" },
    color: "#00CFA8",
    followers: "148K",
    quote: {
      de: "Ich hab aufgehört, gegen mich selbst zu arbeiten – und angefangen, den Stress hinter mir zu lassen.",
      en: "I stopped working against myself — and started leaving the stress behind.",
    },
    image: lifeNeon,
    slug: "miakampft",
    reels: [lifeNeon, lifeFacepaint, lifeTravel],
    story: {
      de: "Mia ist Content-Creatorin und Ex-Dauergestresste. Zwischen Deadlines, Feed und Fitnessstudio hätte der Stress-Sturm sie fast verschluckt – bis sie ihre Routine komplett umgedreht hat. Heute teilt sie sie mit 148K Menschen und beweist: Ruhe ist kein Zufall, sondern eine tägliche Entscheidung.",
      en: "Mia is a content creator and recovering over-stresser. Between deadlines, the feed and the gym the stress storm nearly swallowed her — until she flipped her routine. Today she shares it with 148K people, proving calm isn't luck, it's a daily decision.",
    },
  },
  {
    name: "Jonas Berg",
    handle: "@jonas.nightmode",
    role: { de: "Sleep Rebel", en: "Sleep Rebel" },
    fights: { de: "Immune Booster", en: "Immune Booster" },
    color: "#B084FF",
    followers: "92K",
    quote: {
      de: "3 Uhr nachts war mein Feind. Jetzt gehört mir die Nacht wieder.",
      en: "3am used to be my enemy. Now the night is mine again.",
    },
    image: lifeHome,
    slug: "jonas-nightmode",
    reels: [lifeHome, lifeNeon, lifePilates],
    story: {
      de: "Jonas war jahrelang um 3 Uhr nachts wach. Als DJ war die Nacht sein Business – und sein Feind. Mit Immune Booster und einer klaren Routine hat er seine Abwehr zurückgeholt. Sein Motto: Wer die Nacht gewinnt, gewinnt den Tag.",
      en: "Jonas spent years wide awake at 3am. As a DJ the night was his business — and his enemy. With Immune Booster and a clear routine he got his defences back. His motto: win the night, win the day.",
    },
  },
  {
    name: "Lea Sommer",
    handle: "@leaonthemove",
    role: { de: "Sugar-Slayer", en: "Sugar Slayer" },
    fights: { de: "Sugar Balance", en: "Sugar Balance" },
    color: "#FF3366",
    followers: "231K",
    quote: {
      de: "Der 15-Uhr-Crash hatte mich im Griff. Nicht mehr.",
      en: "The 3pm crash owned me. Not anymore.",
    },
    image: lifeTravel,
    slug: "leaonthemove",
    reels: [lifeTravel, lifeFacepaint, lifeFestival],
    story: {
      de: "Lea reist, tanzt, lebt laut – und kannte den 15-Uhr-Zucker-Crash nur zu gut. Statt Verzicht setzt sie auf Balance: Sugar Balance im Bauchtäschchen, überall auf der Welt. Mit 231K Follower:innen ist sie das lauteste Gesicht des Clubs.",
      en: "Lea travels, dances, lives loud — and knew the 3pm sugar crash all too well. Instead of restriction she chose balance: Sugar Balance in her belt bag, everywhere in the world. With 231K followers she's the loudest face of the club.",
    },
  },
  {
    name: "Deniz Yıldız",
    handle: "@deniz.moves",
    role: { de: "Pilates Powerhouse", en: "Pilates Powerhouse" },
    fights: { de: "Stress Balance", en: "Stress Balance" },
    color: "#D4FF00",
    followers: "67K",
    quote: {
      de: "Balance ist kein Ziel. Es ist eine tägliche Routine – und die macht Spaß.",
      en: "Balance isn't a goal. It's a daily routine — and it feels good.",
    },
    image: lifePilates,
    slug: "deniz-moves",
    reels: [lifePilates, lifeNeon, lifeHome],
    story: {
      de: "Deniz unterrichtet Pilates und lebt Balance nicht als Ziel, sondern als tägliche Routine mit Grinsen. Stress Balance gehört zu ihrer Morning-Routine wie der Reformer. Sie zeigt 67K Menschen, dass Gesundheit laut, bunt und alles andere als langweilig sein darf.",
      en: "Deniz teaches Pilates and lives balance not as a goal but as a daily routine with a grin. Stress Balance is part of her morning routine like the reformer. She shows 67K people that health can be loud, colourful and anything but boring.",
    },
  },
];

export const SOCIAL = [
  {
    handle: "@leaonthemove",
    image: lifeFacepaint,
    likes: "12.4K",
    setting: { de: "Festival", en: "Festival" },
    caption: {
      de: "Sonne, Bass und mein Sugar Balance im Bauchtäschchen 💥 #fightforyourself",
      en: "Sun, bass and my Sugar Balance in the belt bag 💥 #fightforyourself",
    },
  },
  {
    handle: "@deniz.moves",
    image: lifePilates,
    likes: "8.9K",
    setting: { de: "Pilates Studio", en: "Pilates Studio" },
    caption: {
      de: "Reformer + Stress Balance = mein ruhigster Montag ever ✨ @antiunhealthyclub",
      en: "Reformer + Stress Balance = my calmest Monday ever ✨ @antiunhealthyclub",
    },
  },
  {
    handle: "@jonas.nightmode",
    image: lifeHome,
    likes: "5.2K",
    setting: { de: "Cosy Home", en: "Cosy Home" },
    caption: {
      de: "Sonntag-Reset: Tee, Decke, Immune Booster. Die Erkältungswelle hat heute Pause ✨",
      en: "Sunday reset: tea, blanket, Immune Booster. The cold season's off duty today ✨",
    },
  },
  {
    handle: "@miakampft",
    image: lifeTravel,
    likes: "9.7K",
    setting: { de: "Travel", en: "Travel" },
    caption: {
      de: "Neue Stadt, gleiche Routine. Wellness era, baby 🧡 #antiunhealthyclub",
      en: "New city, same routine. Wellness era, baby 🧡 #antiunhealthyclub",
    },
  },
  {
    handle: "@thecrew",
    image: lifeFestival,
    likes: "21.1K",
    setting: { de: "Club-Meetup", en: "Club Meetup" },
    caption: {
      de: "\"Fight For Yourself\"-Meetup im Park. 200 Leute, 100 % gute Laune ✨",
      en: "\"Fight For Yourself\" meetup in the park. 200 people, 100% good vibes ✨",
    },
  },
  {
    handle: "@leaonthemove",
    image: lifeNeon,
    likes: "14.0K",
    setting: { de: "Night Out", en: "Night Out" },
    caption: {
      de: "Tanzen bis 2, aber Immune Booster danach. Balance eben 🌈",
      en: "Dancing till 2, but Immune Booster after. That's balance 🌈",
    },
  },
];
